import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import { connect } from 'react-redux';
import {translate} from "react-i18next";
import cx from 'classnames';
import { SidebarFooter } from '../Sidebar/SidebarFooter/index';
import Login from './Login';
import Registration from './Registration';
import { checkUserClick, loginButtonClick, requestPasswordClick, resetPhoneClick, confirmRegisterClick } from './actions';
import phoneCodes from './phone-codes.json';
import 'react-phone-number-input/style.css';
import 'react-responsive-ui/style.css';
import ru from 'react-phone-number-input/locale/ru';
import PhoneInput from 'react-phone-number-input/basic-input';
import { isValidPhoneNumber, formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input';
import FloatingLabelInput from '../common/FloatingLabelInput'
import { Stats } from 'fs';
import * as countries from 'i18n-iso-countries';

countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
countries.registerLocale(require("i18n-iso-countries/langs/ru.json"));
countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
countries.registerLocale(require("i18n-iso-countries/langs/de.json"));
countries.registerLocale(require("i18n-iso-countries/langs/pt.json"));

@translate(['auth', 'login'], {wait:true})
class Auth extends Component {
  constructor(props) {
    super(props);

    this.state = {
      region: '+7',
      phone: '',
      formattedIntl: '',
      formattedNat: '',
      validPhone: false,
      iso_code: 'RU',
      floating: false
    };
  }

  // shouldComponentUpdate(nextProps) {
  //   if (this.props.isAuthenticated === false && nextProps.isAuthenticated === true) return false;
  //   return true;
  // }

  handleRegion = (e) => {
    const region = e.target.value
    const iso_code = e.target.options[e.target.selectedIndex].dataset.isoCode.split(' / ')[0];
    const formattedIntl = formatPhoneNumberIntl(region + this.state.phone).replace(/\s/g, '');
    const formattedNat = formatPhoneNumber(region + this.state.phone).replace(/\s/g, '');
    this.setState({
      region: region,
      formattedIntl: formattedIntl,
      formattedNat: formattedNat,
      validPhone: this.state.phone.length > 0,
      iso_code: iso_code
    })
  }

  handlePhoneChange = (phone) => {
    const formattedIntl = formatPhoneNumberIntl(this.state.region + phone).replace(/\s/g, '');
    const formattedNat = formatPhoneNumber(this.state.region + phone).replace(/\s/g, '');

    if (phone != this.state.phone && this.props.existenceChecked){
      this.props.handleResetPhoneClick();
    }

    this.setState({
      isAuthSubmitting: false,
      phone: phone,
      formattedIntl: formattedIntl,
      formattedNat: formattedNat,
      validPhone: phone.length > 0
    })
  }

  onPhoneFocus = (e) => {
    this.setState({floating: true})
  }

  onPhoneBlur = (e) => {
    if (e.target.value.length > 0){
      this.setState({floating: true})
    }
    if (e.target.value.length == 0){
      this.setState({floating: false})
    }
  }

  onPhoneLabelClick = () => {
    this._phoneInput.focus()
  }

  getCountries = () => {
    const { t, currentLanguage } = this.props;
    const codes = phoneCodes.sort().map((country) =>
      <option value={"+" + country[1]} data-iso-code={country[2]}>{countries.getName(country[2].split(' / ')[0], currentLanguage)}</option>
    );
  }

  render() {
    const { validPhone, phone, formattedIntl, formattedNat, iso_code, floating } = this.state
    const token = JSON.parse(localStorage.getItem('authToken')),
          { t, currentLanguage } = this.props;
    
    const codes = phoneCodes.sort(
      function(a , b){
        let nameA = countries.getName(a[2].split(' / ')[0], currentLanguage)
        let nameB = countries.getName(b[2].split(' / ')[0], currentLanguage)

        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        return 0
      }
    ).map((country) =>
      <option key={country[2]} value={"+" + country[1]} data-iso-code={country[2]}>{countries.getName(country[2].split(' / ')[0], currentLanguage)}</option>
    );

    let tokenExist = false;
    if (token !== null && typeof token === 'object' && token.access_token !== null) tokenExist = true;
    
    const floatingClass = floating ? 'floating' : ''
    return (
      tokenExist && this.props.devices.length ? null : <div id="popupLogin" className="popapWrapper active" style={{display: 'flex'}}>
        <div ref="modal" className="popup" style={{
          width: 640,
          minHeight: 566,
          margin: 'auto',
          position: 'static',
        }}>
          { (this.props.existenceChecked && !this.props.userIsRegistered) || (this.props.isAuthenticated && !this.props.contracts.length) ?
            <Registration />
            :
            <div className="container">
              <form className="popupForm popupPasswordForm" action="#">
                <div className="popup-car-wrap">
                  <img width="91" height="86" src="images/img-popup-car.png" alt="" />
                  <i></i>
                </div>
                <div className="stepTitle">
                  <h2>{t('auth:welcome')}</h2>
                  <p>{t('auth:enterPhone')}</p>
                </div>
                <div className="popupForm__body">
                  <div className="form-row row">
                    <label className="control control--select control--region">
                      <span className="control__label">{t('auth:region')}</span>
                      <div className="control__wrapper">
                        <select
                          className="control__input"
                          value={ this.state.region }
                          onChange={e => this.handleRegion(e)}>
                          { codes }
                        </select>
                        <span className="country_label">{this.state.region}</span>
                      </div>
                    </label>

                    <div className="floating-label-input margin-left-24 control">
                      <label onClick={this.onPhoneLabelClick} className={floatingClass} >{t('auth:phone')}</label>
                      <PhoneInput
                        ref={(e) => this._phoneInput = e}
                        country={iso_code}
                        value={this.state.phone}
                        onChange={value => this.handlePhoneChange(value)}
                        onFocus={this.onPhoneFocus}
                        onBlur={this.onPhoneBlur}
                      />

                    </div>
                  </div>

                  { this.props.userIsRegistered && this.props.existenceChecked &&
                    <div className="row error">
                      <span className="control__label">{t('auth:password')}</span>
                      <div className="control__wrapper">
                        <input className="control__input inputText" type="password" onChange={e => {
                          this.setState({
                            password: e.target.value,
                          });
                        }}/>
                        <div className="hint-message float-left">{t('auth:passwordSent')}</div>
                        <div className="get-new-password float-right">
                        <a
                          onClick={e => {
                            e.preventDefault();
                            this.props.handleRequestPasswordClick(this.state.phone);
                          }}
                          href="">{t('auth:getNew')}</a>
                        </div>
                        { this.props.error.length > 0 ? <span className="error-message">{t('login:invalidPassword')}</span> : null }
                      </div>
                    </div>
                  }
                  <div className="message">
                    {(this.props.existenceChecked && !this.props.userIsRegistered) &&

                      <div className="phone-is-not-registered">
                         {t('auth:phone_not_registered')}
                      </div>
                    }
                  </div>
                </div>
                <div className="rowButton">
                  { (!this.props.userIsRegistered && !this.props.existenceChecked) &&
                    <button
                      disabled={!validPhone}
                      onClick={e => {
                        e.preventDefault();
                        this.setState({isAuthSubmitting: true});
                        this.props.handleCheckUserClick({phone: formattedIntl});
                      }} className="btn">{ this.state.isAuthSubmitting ? <span className="spinner"></span> : t('auth:continue') }</button>
                  }

                  { (!this.props.userIsRegistered && this.props.existenceChecked) &&
                    <button
                      disabled={!validPhone}
                      onClick={e => {
                        e.preventDefault();
                        this.setState({isRegistrationSubmitting: true, register: true});
                      }} className="btn">{ this.state.isRegistrationSubmitting ? <span className="spinner"></span> : t('auth:createAccount') }</button>
                  }

                  { this.props.userIsRegistered && this.props.existenceChecked &&
                    <button onClick={e => {
                      e.preventDefault();
                      this.setState({isLoginSubmitting: true});
                      this.props.isConfirm ? this.props.handleRegisterConfirmClick(this.state.password) : this.props.handleLoginClick(this.state.password);
                    }} className="btn" href="">{ this.state.isLoginSubmitting ? <span className="spinner"></span> : t('login:continue') }</button>
                  }
                </div>
              </form>
            </div>
          }
          <SidebarFooter />
        </div>
        <a href="" data-close className="overlay" onClick={e => e.preventDefault()}></a>
      </div>
    );
  }
}

Auth.propTypes = {
  handleCheckUserClick: PropTypes.func,
  error: PropTypes.string,
  userIsRegistered: PropTypes.bool,
  existenceChecked: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  registerNotFinished: PropTypes.bool,
  contracts: PropTypes.array,
  devices: PropTypes.array,
};

export default connect(
  (state) => {
    return {
      error: state.auth.error,
      userIsRegistered: state.auth.userIsRegistered,
      existenceChecked: state.auth.existenceChecked,
      isAuthenticated: state.auth.isAuthenticated,
      contracts: state.contracts.contracts,
      devices: state.devices.devices,
      currentLanguage: state.langs.currentLanguage
    };
  },
  (dispatch) => {
    return {
      handleCheckUserClick(payload) {
        return dispatch(checkUserClick(payload));
      },
      handleRequestPasswordClick() {
        return dispatch(requestPasswordClick());
      },
      handleLoginClick(password) {
        return dispatch(loginButtonClick({password}));
      },
      handleRegisterConfirmClick(password) {
        return dispatch(confirmRegisterClick({password}));
      },
      handleResetPhoneClick() {
        return dispatch(resetPhoneClick());
      },
    };
  },
)(Auth);



// WEBPACK FOOTER //
// ./src/components/Auth/index.js